import { useMutation } from '@tanstack/react-query'
import { createAppointment } from '../services/bookingsService'
import type { BookingAppointmentPayload } from '../types/bookings'

export function useCreateAppointment() {
  return useMutation({
    mutationFn: (payload: BookingAppointmentPayload) =>
      createAppointment(payload),
  })
}
